import defaultAttributes from '../defaultAttributes';

const Network = [
  'svg',
  defaultAttributes,
  [
    ['rect', { x: '9', y: '2', width: '6', height: '6' }],
    ['rect', { x: '16', y: '16', width: '6', height: '6' }],
    ['rect', { x: '2', y: '16', width: '6', height: '6' }],
    ['path', { d: 'M12 8v4m0 0H5v4m7-4h7v4' }],
  ],
];

export default Network;
